import type { FaireProductEntity } from "../../entity_types/product";

export const p_7tpkv3ozqp: FaireProductEntity = {
  token: "p_7tpkv3ozqp",
  type: "product",
  name: "Original Extra Virgin Olive Oil (500ml)",
  brandToken: "b_8v4yrvb98p",
  brandName: "Kosterina",
  imageUrl:
    "https://cdn.faire.com/fastly/5f562e53de77a291b5786b09a3bf6ca5fa7f7c0a19104c09f877b74940c7c78e.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ec4f9b14eb2c941aabbaa67986528450b82eaf11a3391c029f0729b1e0890013.jpeg",
    "https://cdn.faire.com/fastly/f4163dc7bddf6b87d43746106ec3616a058591a668bc9048e3e8bb967d6e53dd.jpeg",
    "https://cdn.faire.com/fastly/36e2fd34f5897268ef4982c4759f6c8624c679ef3e7afbda5613916662ad753e.jpeg",
    "https://cdn.faire.com/fastly/e44c79095a9171307941821d4b4fb84b1240734ad4b33990655577f8815c1c58.jpeg",
  ],
  priceDollars: 29.79,
  description:
    "Award Winning Olive Oil: Named the 2025 World's Best Olive Oil by NYIOOC World Olive Oil Competition\n\nElevate your everyday with our Original Extra Virgin Olive Oil. Cold pressed in small batches from a single blend of early harvest Koroneiki olives grown in the Peloponnese region of southern Greece, our EVOO has a high chlorophyll content, making it rich in healthy polyphenols (an anti-inflammatory antioxidant). Polyphenol content measuring over 55mg/kg is required for an olive oil to be deemed extra virgin - this Kosterina harvest measured 430 mg/kg of polyphenol content!.",
  tags: [],
  msrpDollars: 44.34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:41.722Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
